import styled from '@emotion/styled';
import { imagePath } from 'presentations/assets';
import { mediaMax, spacing } from 'presentations/views/styles';
import { ReactNode } from 'react';

interface Props {
  children?: ReactNode;
  className?: string;
  id?: string;
}

export default function Component(props: Props) {
  return (
    <Container id={props.id} className={props.className}>
      <Inner>{props.children}</Inner>
    </Container>
  );
}

const Inner = styled.div`
  max-width: 1080px;
  margin: 0 auto;
`;

const Container = styled.div`
  padding: ${spacing(48)} ${spacing(16)} ${spacing(48)};
  background: url(${imagePath('pages/top/202306/bg-line.svg', {
      width: 530,
      height: 644,
    })})
    no-repeat right 0px bottom 0px;
  background-size: 530px auto;
  :last-of-type {
    margin-bottom: 0;
  }

  ${mediaMax.tablet} {
    background-size: 300px auto;
  }
  ${mediaMax.smartphone} {
    background-size: 150px auto;
  }
`;
